<div class="offcanvas offcanvas-start mt-2" tabindex="-1" id="topics" aria-labelledby="topics_label">
  <div class="offcanvas-body">
  <div class="d-flex justify-content-between mt-5">
        <div class="d-flex align-items-center mt-3">
            <h5 class="offcanvas-title mx-2" id="portals_label">Segments</h5>
            <CreateSegment ref="createSegment" @newSegment="$emit('newSegment', $event)" class="mx-2" />
        </div>

            <button type="button" class="btn-close text-reset mt-4" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
    <div class="reports">
      <div class="table-container">
        <div v-if="isLoading" class="text-center py-5 w-100">
                    <div class="spinner-border text-secondary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2 mb-0 text-muted">Loading Segments...</p>
                  </div>
                  <div v-else>
                    <table v-if="topics.length" class="table mb-0">
                    <tbody>
                      <tr v-for="topic in topics" :key="topic.id" class="hover-row border-0">
                        <td class="border-0">

                          <a class="text-decoration-none text-dark d-flex align-items-center" href="#" @click.prevent="handleTopicClick(topic.id)" data-bs-dismiss="offcanvas" >


                              <span class="rounded-circle bg-yellow p-1 shadow-sm color-purple">
                                <i class="bx bxs-bulb fs-5 text-change"></i>
                              </span>
                              <span class="text-xs fw-500 mx-2">{{ topic.name || topic_name.name }}</span>

                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p v-else class="text-secondary text-xs text-center">
                    No Segments Available
                  </p>

                  </div>

      </div>
    </div>
  </div>

</div>
<div class="d-none d-xl-block">
  <!-- Segments Section -->
  <div class="card bg-transparent border rounded shadow-sm mt-2">
    <div class="card-header bg-transparent d-flex justify-content-between align-items-center border-bottom">
      <h6 class="mb-0 card-header bg-transparent border-0">Segments</h6>


      <CreateSegment
        @newSegment="$emit('newSegment', $event)"
      />

    </div>
    <div class="mb-2 text-start d-none">
      <span
        class="btn btn-primary btn-sm ms-2 mt-2 text-xs rounded"
        @click="$emit('clear_reports')"
      >
        Clear Filtering
    </span>
    </div>
    <div class="card-body ">
    <div v-if="isLoading" class="text-center py-5 w-100">
                        <div class="spinner-border text-secondary" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="mt-2 mb-0 text-muted">Loading Segments...</p>
                      </div>
                      <div v-else>
          <table v-if="topics.length" class="table mb-0">
            <tbody>
              <tr v-for="topic in topics" :key="topic.id" class="border-0">
                <td class="border-0 align-middle">
                  <div class="d-flex justify-content-between align-items-center">
                    <a
                      class="text-decoration-none text-dark d-flex align-items-center"
                      href="#"
                      @click.prevent="handleTopicClick(topic.id)"
                    >
                      <span class="rounded-circle bg-yellow p-2 shadow-sm color-purple d-flex align-items-center justify-content-center me-2">
                        <i class="bx bxs-bulb fs-5 text-change"></i>
                      </span>
                      <span class="text-xs fw-500">{{ topic.name || topic_name.name }}</span>
                    </a>
                    <div v-if="user_details.user_role === 'admin'" class="dropdown">
                      <i class="bx bx-dots-vertical-rounded cursor-pointer" data-bs-toggle="dropdown"></i>
                      <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                          <a class="dropdown-item text-xs" data-bs-toggle="modal" data-bs-target="#edit_segment_modal" href="" @click="openEditSegmentModal(topic)">Edit</a>
                        </li>
                        <li>
                          <a class="dropdown-item text-xxs text-danger" href="#" @click="deleteSegment(topic.id)">Delete</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <p v-if="!isLoading && !topics.length" class="text-secondary text-xs text-center">No Segments Available</p>
          </div>
    </div>
  </div>
  
</div>


<div class="offcanvas offcanvas-start" tabindex="-1" id="portal_members" aria-labelledby="portal_members_label">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="portal_label"></h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
      <h6 class='text-start mx-1 d-flex align-items-center'>Portal Members
        <i 
          class="bx bx-plus-circle fs-5 text-primary ms-2 cursor-pointer" 
          data-bs-toggle="modal" 
        data-bs-target="#add_portal_member_modal"
          title="Add Member" v-if="user_details.user_role=='admin'">
        </i>
        <i
          class="bx bx-trash fs-5 text-danger ms-2 cursor-pointer"
          data-bs-toggle="modal" 
        data-bs-target="#delete_portal_member_modal"
          title="Delete Member" v-if="user_details.user_role=='admin'">
        </i>
        </h6>

      <div class="table-container ">
        <table v-if="members.length" class="table mb-0">
          <tbody>
            <tr v-for="member in members" :key="member.id" class="hover-row border-0">
              <td class="border-0">
                <span class="text-decoration-none text-dark">
                  <p class="portal-icon mb-0 d-flex align-items-center">
                    <a class="rounded-circle bg-yellow p-1 shadow-sm color-purple">
                      <i class='bx bx-user fs-5'></i>
                    </a>
                    <span class="text-sm fw-bold mx-3">
                      <a :href="getProfileLink(member)"
                         class="text-decoration-none text-dark">
                        {{ member.first_name }} {{ member.last_name }}
                      </a>
                    </span>
                  </p>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else class="text-secondary text-xs text-center">
          No Portal members Available
        </p>
      </div>
  </div>
</div>